import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUndo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.375 13.75L5 9.375M5 9.375L9.375 5M5 9.375H14.1875C14.8195 9.375 15.4453 9.49948 16.0292 9.74133C16.613 9.98318 17.1436 10.3377 17.5905 10.7845C18.0373 11.2314 18.3918 11.762 18.6337 12.3458C18.8755 12.9297 19 13.5555 19 14.1875C19 14.8195 18.8755 15.4453 18.6337 16.0292C18.3918 16.613 18.0373 17.1436 17.5905 17.5905C17.1436 18.0373 16.613 18.3918 16.0292 18.6337C15.4453 18.8755 14.8195 19 14.1875 19H11.125",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgUndo);
export { ForwardRef as ReactComponent };
